var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoneybagWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 11V11.01",
    stroke: "#E0E6E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3V6.803C17.2376 7.51912 18.1799 8.65245 18.658 10H19.999C20.2642 10 20.5186 10.1054 20.7061 10.2929C20.8936 10.4804 20.999 10.7348 20.999 11V13C20.999 13.2652 20.8936 13.5196 20.7061 13.7071C20.5186 13.8946 20.2642 14 19.999 14H18.657C18.3206 14.9504 17.7504 15.8008 16.999 16.473V18.5C16.999 18.8978 16.841 19.2794 16.5597 19.5607C16.2783 19.842 15.8968 20 15.499 20C15.1012 20 14.7196 19.842 14.4383 19.5607C14.157 19.2794 13.999 18.8978 13.999 18.5V17.917C13.6685 17.9724 13.334 18.0001 12.999 18H8.99899C8.66393 18.0001 8.32945 17.9724 7.99899 17.917V18.5C7.99899 18.8978 7.84096 19.2794 7.55965 19.5607C7.27835 19.842 6.89682 20 6.49899 20C6.10117 20 5.71964 19.842 5.43833 19.5607C5.15703 19.2794 4.99899 18.8978 4.99899 18.5V16.5L4.99999 16.473C4.09402 15.663 3.45536 14.597 3.16853 13.4161C2.88171 12.2352 2.96025 10.995 3.39375 9.85969C3.82726 8.72438 4.59529 7.74747 5.59621 7.05826C6.59712 6.36904 7.78373 6.00001 8.99899 6H11.499L15.999 3H16Z",
    stroke: "#E0E6E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoneybagWhite);
export default __webpack_public_path__ + "static/media/icon_moneybag_white.0ffb214f652afdf9c03a77a190f97b02.svg";
export { ForwardRef as ReactComponent };